import LegalPageLayout, { Sec, List } from "@/components/legal/LegalPageLayout";
import { LEGAL_DOCUMENTS } from "@/lib/legalDocuments";

export default function WebsiteDisclaimer() {
  return (
    <LegalPageLayout
      document={LEGAL_DOCUMENTS.disclaimer}
      seoDescription="Website Disclaimer for Hannah Howard Funding."
    >
      <Sec title="General Information">
        <p>The information provided on the Hannah Howard Funding website ("Services") is intended solely for general informational purposes regarding our commission advance services.</p>
        <p>Although we strive to keep information accurate and current, Hannah Howard Funding makes no representation or warranty regarding the accuracy, completeness, reliability, suitability, availability, or timeliness of any information presented on the Services.</p>
        <p>Website content may be modified, updated, or removed at any time without prior notice.</p>
      </Sec>

      <Sec title="No Offer or Commitment">
        <p>Nothing contained on this website constitutes:</p>
        <List items={[
          "a commitment to provide funding;",
          "an approval of any application;",
          "an offer of consumer credit;",
          "a guarantee of eligibility;",
          "a guarantee of funding;",
          "legal advice;",
          "tax advice;",
          "accounting advice;",
          "financial planning advice; or",
          "professional advice of any kind.",
        ]}/>
        <p>Any funding transaction is subject to Hannah Howard Funding's underwriting process, verification procedures, internal policies, and execution of a separate written Funding Agreement.</p>
      </Sec>

      <Sec title="Funding Decisions">
        <p>Every application is evaluated individually.</p>
        <p>Funding decisions are based upon numerous factors, including but not limited to:</p>
        <List items={[
          "transaction eligibility;",
          "documentation;",
          "brokerage verification;",
          "title verification;",
          "fraud prevention review;",
          "identity verification;",
          "operational requirements;",
          "applicable law; and",
          "execution of all required agreements.",
        ]}/>
        <p>Submission of an inquiry or application does not create any contractual right to funding.</p>
      </Sec>

      <Sec title="No Professional Advice">
        <p>The Services do not provide legal, tax, accounting, financial, investment, brokerage, or other professional advice.</p>
        <p>Visitors should consult qualified professionals regarding their individual circumstances before making financial or legal decisions.</p>
      </Sec>

      <Sec title="Third-Party Services">
        <p>The Services may integrate with or reference third-party providers that assist in delivering our services, including appointment scheduling, communications, identity verification, payment processing, electronic signatures, document management, analytics, and other operational services.</p>
        <p>Hannah Howard Funding is not responsible for the content, availability, security, privacy practices, or policies of third-party websites or services.</p>
        <p>Use of third-party services remains subject to those providers' own terms and policies.</p>
      </Sec>

      <Sec title="Website Availability">
        <p>Although we make reasonable efforts to maintain website availability, uninterrupted access cannot be guaranteed.</p>
        <p>The Services may be temporarily unavailable due to:</p>
        <List items={[
          "scheduled maintenance;",
          "software updates;",
          "internet disruptions;",
          "cybersecurity incidents;",
          "banking interruptions;",
          "failures of third-party providers;",
          "natural disasters;",
          "governmental actions; or",
          "other events beyond our reasonable control.",
        ]}/>
      </Sec>

      <Sec title="Limitation of Reliance">
        <p>You agree that any reliance upon information presented through the Services is at your own risk.</p>
        <p>Official transaction terms are governed exclusively by the executed Funding Agreement.</p>
        <p>If any information appearing on the website conflicts with a fully executed Funding Agreement, the Funding Agreement shall control with respect to the applicable transaction.</p>
      </Sec>

      <Sec title="Intellectual Property">
        <p>Unless otherwise indicated, all website content, including text, graphics, branding, logos, designs, layouts, images, software, and other materials, is owned by or licensed to Hannah Howard Funding and is protected by applicable intellectual property laws.</p>
        <p>No content may be copied, reproduced, distributed, modified, or used for commercial purposes without prior written permission.</p>
      </Sec>

      <Sec title="Artificial Intelligence and Automated Data Collection">
        <p>The content, layout, branding, application workflow, forms, documents, and other proprietary materials available through the Services may not be used to train, develop, or improve artificial intelligence systems, machine learning models, automated datasets, or similar technologies without Hannah Howard Funding's prior written consent.</p>
        <p>Automated scraping, harvesting, indexing beyond standard search-engine indexing, or commercial reuse of website content is prohibited.</p>
      </Sec>

      <Sec title="Contact">
        <p>Questions regarding this Disclaimer may be directed to:</p>
        <p>
          Hannah Howard Funding<br />
          Email: hello@hannahhowardfunding.com<br />
          Phone: (870) 919-9520<br />
          Mailing Address: 495 Brickell Ave Miami, FL 33131
        </p>
      </Sec>
    </LegalPageLayout>
  );
}
